import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { uploadSales } from 'services/api/requests/uploads/uploads';
import {
	cleanupBulkCreateLogStorage,
	createBulkCreateErrorLog,
	createBulkCreateSuccessLog,
} from 'utils/logging/bulkCreateLogger';

export const useUploadSales = (
	setSucessUpload,
	openTableModal,
	isOpen,
	onClose
) => {
	const toast = useToast();

	return useMutation(data => uploadSales(data), {
		onSuccess: async (success: { quantidade_erros?: number }) => {
			if (
				success.hasOwnProperty('quantidade_erros') &&
				success.quantidade_erros !== undefined &&
				success.quantidade_erros > 0
			) {
				await createBulkCreateErrorLog('/bulkCreate/sale', {
					quantidade_erros: success.quantidade_erros,
					errors: '[]',
				});
				cleanupBulkCreateLogStorage('/bulkCreate/sale');

				openTableModal();
				setSucessUpload(false);
				if (!isOpen) {
					toast({
						title: 'Arquivo enviado com erros!',
						description:
							'O Arquivo enviado possui erros. Verifique a tabela de erros e corrija-os.',
						position: 'bottom-left',
						status: 'error',
						duration: 8000,
						isClosable: true,
					});
				}
			} else {
				await createBulkCreateSuccessLog('/bulkCreate/sale');
				cleanupBulkCreateLogStorage('/bulkCreate/sale');

				setSucessUpload(true);
				onClose();
			}
		},
		onError: async () => {
			await createBulkCreateErrorLog('/bulkCreate/sale', {
				message: 'Erro desconhecido ao fazer upload do arquivo',
			});
			cleanupBulkCreateLogStorage('/bulkCreate/sale');

			onClose();
			toast({
				title: 'Erro desconhecido!',
				description: 'Tente enviar novamente.',
				position: 'bottom-left',
				status: 'error',
				duration: 8000,
				isClosable: true,
			});
			setSucessUpload(false);
		},
	});
};
